import { useId } from 'react';
import { Input } from '@artosera/ui';
import type { DimensionsCaisse as Dimensions } from '@artosera/shared';
import { useTranslation } from 'react-i18next';
import { Field } from '../Field.js';
import styles from './InventairePage.module.css';

export function DimensionsCaisse({
  titre,
  valeur,
  onChange,
}: {
  titre: string;
  valeur: Partial<Dimensions>;
  onChange: (valeur: Partial<Dimensions>) => void;
}) {
  const { t } = useTranslation('regie');
  const id = useId();
  return (
    <fieldset>
      <legend>{titre}</legend>
      <div className={styles.dimensions}>
        {(['hauteur', 'largeur', 'profondeur'] as const).map((cle) => (
          <Field key={cle} htmlFor={`${id}-${cle}`} label={t(`inventaire.${cle}`)}>
            <Input
              id={`${id}-${cle}`}
              type="number"
              min="0.01"
              step="any"
              value={valeur[cle] ?? ''}
              onChange={(e) =>
                onChange({ ...valeur, [cle]: e.target.value ? Number(e.target.value) : undefined })
              }
            />
          </Field>
        ))}
      </div>
    </fieldset>
  );
}
export function dimensionsCompletes(valeur: Partial<Dimensions>): Dimensions | null {
  if (valeur.hauteur && valeur.largeur && valeur.profondeur)
    return { hauteur: valeur.hauteur, largeur: valeur.largeur, profondeur: valeur.profondeur };
  return null;
}
export function dimensionsValides(valeur: Partial<Dimensions>): boolean {
  const valeurs = Object.values(valeur).filter((v) => v !== undefined);
  return valeurs.length === 0 || (valeurs.length === 3 && valeurs.every((v) => v > 0));
}
